
const IssueResponse = {
	// "version": "1.0.0.0",
	// "statusCode": 200,
	// "message": "OK",
	// "responseException": null,
	// "result": {}
		"category": 0,
		"gdsRefrenceID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
		"uniqueId": "string",
		"totalPrice": 0,
		"statusCode": 100
	
};
 

  export default IssueResponse;
  